module.exports = __webpack_public_path__ + "3ee26adb6b9873c8d9caceea7859b428.webp";